<div class="side-nav" (window:resize)="onResize($event)">
  <div class="button" *ngFor="let btn of button_list" [class.button-selected]="checkPath(btn.link)" (click)="moveToPage(btn)">
    <div class="hover-area" [class.button-selected]="checkPath(btn.link)"> 
      <i class="material-icons">{{btn.icon}}</i>
      <div style="height: 24px;position: absolute;left: 70%; top: 30%" *ngIf="btn.badge !== 0">
        <div style="background-color:red; height:4px;width:4px;border-radius: 4px;"></div>
      </div>
      <div class="tooltip">{{btn.name}}</div>
    </div>
  </div>
</div>
<div class="loader absolute" *ngIf="commonService.isLoading">
  <svg class="circular" viewBox="25 25 50 50">
    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
  </svg>
</div>